export default [
    {
        path: '/current-user-product/list/:share?',
        name: 'current_user_product_list',
        component: () => import('@src/user-product/current-user-products.vue'),
        props(route: any) {
            return { ...route.params };
        },
        meta: {
            title: 'Meine Produkte',
            favoriteRouteName: 'current_user_product_list',
        },
    },
];
